<template>
    <div>
        <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" class="mr-2" v-on="on">mdi-dots-vertical</v-icon>
            </template>
            <v-list class="py-0">
                <span v-for="(item, i) in items" :key="i">
                    <v-list-item  class="item" @click="ligaAction(item)" :disabled="item.disabled ||
                                                        (item.disableIfEmpty&&!saisonExisting)">
                        <v-list-item-icon class="mr-3">
                            <v-icon>{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="pr-3">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="item.divider"></v-divider>
                </span>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: "liga-edit-menu",
        props: ['saisonExisting'],
        computed: {
            user(){ return this.$store.state.user },
            items(){
                return this.user.permissions.ergebnisdienst ?
                    this.allItems : this.isSportObmann ? this.allItems.filter(item => item.sportobmann ) :
                        this.allItems.filter(item => item.withoutPermission );
                /*return this.saisonExisting ?
                    [
                        { title: 'Saison ändern', icon: 'mdi-pencil', action: 'editSaison' },
                        { title: 'Saison löschen', icon: 'mdi-trash-can-outline', action: 'deleteSaison', disabled: true },
                        { title: 'Liga ändern', icon: 'mdi-pencil', action: 'edit' },
                        { title: 'Liga löschen', icon: 'mdi-trash-can-outline', action: 'delete' },
                    ] :
                    [
                        { title: 'Liga ändern', icon: 'mdi-pencil', action: 'edit' },
                        { title: 'Liga löschen', icon: 'mdi-trash-can-outline', action: 'delete' },
                    ]*/
            },
            isSportObmann(){
                return this.saisonExisting && this.saisonExisting.lvId ?
                    this.$store.state.user.permissions['sportobmann_' + this.saisonExisting.lvId] : false;
            }
        },
        data: () => ({
            allItems: [
                { title: 'Vereinsdatenblätter', icon: 'mdi-file-table', action: 'displayVereinsdatenblaetter',
                  withoutPermission: true, divider: true, sportobmann: true},
                { title: 'Saison ändern', icon: 'mdi-pencil', action: 'editSaison', disableIfEmpty: true },
                { title: 'Saison löschen', icon: 'mdi-trash-can-outline',
                    action: 'deleteSaison', disabled: true },
                { title: 'Alle Saison-Spiele löschen', icon: 'mdi-trash-can-outline',
                    action: 'deleteSaisonGames', divider: true },
                { title: 'Fristen setzen', icon: 'mdi-pencil', action: 'editSaisonFrist', divider: false },
                { title: 'Tabellenkorrektur', icon: 'mdi-pencil', action: 'editSaisonTable',
                    divider: true, disableIfEmpty: true/*, sportobmann: true */},
                { title: 'Liga ändern', icon: 'mdi-pencil', action: 'edit' },
                { title: 'Liga löschen', icon: 'mdi-trash-can-outline', action: 'delete' },
            ]
        }),
        methods: {
            ligaAction(item){
                this.$emit('ligaAction', item.action);
            },
        },
    }
</script>

<style scoped>
    .item:hover {background-color: #f2f2f2}
</style>